import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Categorie } from '../../models/categorie';
import {environment} from '../../../environments/environment';

@Injectable({
    providedIn: 'root'
})
export class CategorieService {
    private apiUrl = `${environment.parameters_url}api/settings/categorie`;

    constructor(private http: HttpClient) {}

    getCategoriePerStation(idStation: number): Observable<Categorie[]> {
        return this.http.get<any>(`${this.apiUrl}/${idStation}`).pipe(
            map(response => {
              //  console.log('getCategoriePerStation Response:', response);
                return response.categories || [];
            }),
            catchError(this.handleError)
        );
    }

    getAll(idStation: number, idUser: number): Observable<Categorie[]> {
        return this.http.get<any>(`${this.apiUrl}/${idUser}/${idStation}`).pipe(
            map(response => {
              //  console.log('getAll Response:', response);
                return response.categories || [];
            }),
            catchError(this.handleError)
        );
    }

    addCategorie(categorie: Categorie): Observable<Categorie> {
        //console.log('addCategorie Request:', categorie);
        return this.http.post<any>(this.apiUrl, categorie).pipe(
            map(response => {
             //   console.log('addCategorie Raw Response:', JSON.stringify(response, null, 2));
                const newCategory: Categorie = response.categorie || response;
              //  console.log('addCategorie Mapped Category:', newCategory);
                if (!newCategory || !newCategory.libelle || !newCategory.id) {
                    console.warn('Invalid category response:', newCategory);
                    throw new Error('Invalid category response');
                }
                return newCategory;
            }),
            catchError(error => {
                console.error('addCategorie Error:', error);
                return this.handleError(error);
            })
        );
    }

    updateCategorie(categorie: Categorie, idStation: number): Observable<Categorie> {
        return this.http.put<Categorie>(`${this.apiUrl}/${categorie.id}`, { libelle: categorie.libelle }).pipe(
            map(response => {
                //console.log('updateCategorie Response:', response);
                return response;
            }),
            catchError(this.handleError)
        );
    }

    private handleError(error: HttpErrorResponse): Observable<never> {
        let errorMessage = 'Une erreur est survenue lors de la communication avec le serveur.';
        if (error.error instanceof ErrorEvent) {
            errorMessage = `Erreur: ${error.error.message}`;
        } else {
            errorMessage = `Code d'erreur: ${error.status}\nMessage: ${error.message}`;
        }
        console.error('HandleError:', errorMessage);
        return throwError(() => new Error(errorMessage));
    }
}
